import React from 'react';
import Icon from './Icon';

const TONES = {
  ink:   'bg-ink-50 text-ink-700 ring-ink-200',
  leaf:  'bg-leaf-50 text-leaf-800 ring-leaf-200',
  amber: 'bg-amber-50 text-amber-600 ring-amber-100',
  flame: 'bg-flame-50 text-flame-600 ring-flame-100',
  navy:  'bg-ink-700 text-white ring-ink-700',
  ghost: 'bg-paper-100 text-ink-600 ring-ink-100',
};

/**
 * Small pill tag component.
 *
 * Props:
 *   tone      – 'ink' | 'leaf' | 'amber' | 'flame' | 'navy' | 'ghost'
 *   icon      – optional Icon name shown before children
 *   className – extra classes
 */
const Chip = ({ tone = 'ghost', icon, children, className = '' }) => (
  <span
    className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium ring-1 ring-inset ${TONES[tone] || TONES.ghost} ${className}`}
  >
    {icon && <Icon name={icon} size={11} />}
    {children}
  </span>
);

export default Chip;

/** Map a document/envelope status string to a Chip tone */
export const statusTone = (s) => {
  if (s === 'completed' || s === 'signed') return 'leaf';
  if (s === 'in_progress' || s === 'viewed') return 'navy';
  if (s === 'cancelled' || s === 'declined') return 'flame';
  if (s === 'expiring') return 'amber';
  return 'ghost';
};
